import {classNames} from "../../helpers";

const ImageUpload = ({ name, onFileChange }) => {
  return (
    <div className="mb-4">
      <label className="block my-2">
        <span className="sr-only">Choose image</span>
        <input
          name={name}
          type="file"
          accept="image/*"
          onChange={onFileChange}
          className={classNames(
            'block w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg',
            'file:border-0 file:text-sm file:font-semibold file:bg-artfulRed-100 file:text-artfulRed',
            'hover:file:bg-artfulRed-550, focus:outline-none'
          )}
        />
      </label>
      <p className="text-xs text-gray-500">PNG, JPG, JPEG up to 10MB</p>
    </div>
  )
};

export default ImageUpload;
